import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

const CaseStatusesStats = ({ caseStatusesStats }) => {
  return (
    <StatusesStatsContainer>
      <div>Zainicjowane: {caseStatusesStats.initiated}</div>
      <div>Zamknięte: {caseStatusesStats.closed}</div>
      <div>W toku: {caseStatusesStats.pending}</div>
    </StatusesStatsContainer>
  );
};

const StatusesStatsContainer = styled.div`
  margin-bottom: 10px;
`;

CaseStatusesStats.propTypes = {
  caseStatusesStats: PropTypes.object,
};

export { CaseStatusesStats };



// WEBPACK FOOTER //
// ./src/containers/case-statuses/components/CaseStatusesStats.jsx